import { PizzasDTO } from "@/api/custom-schema";
import { usePostGetAllPizzas } from "@/api/pizza-checker/pizzas/pizzas";
import { usePizzaEvaluationContext } from "@/context/pizza-evaluation-context";
import { useBranchFilter } from "@/hooks/use-branch-filter";
import { usePermissions } from "@/hooks/use-permissions";
import { useLocalization } from "@/context/localization-context";

import SelectedProduct from "@/orders/selected-product";
import { useEffect } from "react";

export default function Page() {
  const branchFilter = useBranchFilter();
  const { hasPermission } = usePermissions();
  const { t } = useLocalization();

  const { data } = usePostGetAllPizzas<PizzasDTO>(
    {
      limit: 1,
      skip: 0,
      sort_by: "capture_at",
      sort_order: -1,
      filters: {
        ...branchFilter,
        evaluation: { $exists: true },
      },
    },
    {
      query: {
        enabled: hasPermission("operator.branch"),
        refetchInterval: 5000,
      },
    },
  );

  const pizza = data?.pizzas[0];

  const { setSelectedPizzaId } = usePizzaEvaluationContext();



  useEffect(() => {
    if (pizza?.id) {
      setSelectedPizzaId(pizza.id);
    }
  }, [pizza?.id, setSelectedPizzaId]);

  return (
    <div className="flex h-full flex-col gap-4 p-3 pb-8 sm:p-4">
      {pizza?.id ? (
        <SelectedProduct navigation="none" />
      ) : (
        <div className="mt-8 text-center text-muted-foreground">
          {t("shell.operator.noPizza")}
        </div>
      )}
    </div>
  );
}
